import { render, staticRenderFns } from "./OperationMalfunction.vue?vue&type=template&id=17076c44&scoped=true"
import script from "./OperationMalfunction.vue?vue&type=script&lang=js"
export * from "./OperationMalfunction.vue?vue&type=script&lang=js"
import style0 from "./OperationMalfunction.vue?vue&type=style&index=0&id=17076c44&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17076c44",
  null
  
)

export default component.exports